"use client";
import Image from "next/image";
import Link from "next/link";
import styles from "@/app/styles/footer.module.scss";
import { useEffect, useState } from "react";
import https from "https";
import useDeviceType from "@/app/utils/useDeviceType";
import { usePathname } from "next/navigation";

const agent = new https.Agent({
  rejectUnauthorized: false,
});

async function getPosts() {
  const query = `
{
  globalSettings {
    globalSettingsNew {
      footerText
      openingHours
      smFacebook
      smInstagram
      tripadvisor
      avaniLink
      seenLink
      logoGold {
        node {
          mediaItemUrl
        }
      }
      logoWhite {
        node {
          mediaItemUrl
        }
      }
    }
    globalSettingsNewSmtp {
      addressLine1
      contactEmail
      contactName
      hotlineNumber
    }
  }
  menu(id: "dGVybToz") {
    id
    name
    menuItems {
      nodes {
        id
        label
        cssClasses
        menuItemId
        uri
        url
        target
      }
    }
  }
  bottomMenu: menu(id: "dGVybToyMA==") {
    id
    name
    menuItems {
      nodes {
        id
        label
        cssClasses
        menuItemId
        uri
        url
        target
      }
    }
  }
}
  `;

  const res = await fetch(`${process.env.NEXT_PUBLIC_GRAPHQL_ENDPOINT}`, {
    httpsAgent: agent,
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify({ query }),
    next: {
      revalidate: 60,
    },
  });

  const { data } = await res.json();

  return data;
}

const Footer = () => {
  const [page_data, setPageData] = useState(null);
  const pathname = usePathname();

  const [menu_items, setMenuItems] = useState(null);
  const [bottom_menu_items, setBottomMenuItems] = useState(null);
  const [global_setting, setGlobalSetting] = useState(null);
  const [footer_text, setFooterText] = useState("");
  const [avaniLink, setAvaniLink] = useState("");
  const [seenLink, setSeenLink] = useState("");
  const [phone_number, setPhoneNumber] = useState("");
  const [email_address, setEmailAddress] = useState("");
  const [main_address, setMainAddress] = useState("");
  const [opening_hours, setOpeningHours] = useState("");
  const [fb_link, setFbLink] = useState("");
  const [insta_link, setInstaLink] = useState("");
  const [advisor_link, setAdvisorLink] = useState("");
  const [currentYear, setCurrentYear] = useState(null);

  const [logoGold, setlogoGold] = useState("");
  const [logoWhite, setlogoWhite] = useState("");

  const deviceType = useDeviceType();

  const [activeBottomLink, setActiveBottomNavLink] = useState(null);

  const normalizePath = (path) => {
    return path.replace(/\/+$/, "");
  };

  useEffect(() => {
    setCurrentYear(new Date().getFullYear());
  }, []);

  useEffect(() => {
    const fetchData = async () => {
      const page = await getPosts();

      if (page) {
        setPageData(page);
        if (page.menu) {
          setMenuItems(page.menu);
        }
        if (page.bottomMenu) {
          setBottomMenuItems(page.bottomMenu);
        }
        if (page.globalSettings) {
          if (page.globalSettings.globalSettingsNew) {
            setGlobalSetting(page.globalSettings.globalSettingsNew);

            if (page.globalSettings.globalSettingsNew.footerText) {
              setFooterText(page.globalSettings.globalSettingsNew.footerText);
            }
            if (page.globalSettings.globalSettingsNew.avaniLink) {
              setAvaniLink(page.globalSettings.globalSettingsNew.avaniLink);
            }
            if (page.globalSettings.globalSettingsNew.seenLink) {
              setSeenLink(page.globalSettings.globalSettingsNew.seenLink);
            }
            if (page.globalSettings.globalSettingsNew.openingHours) {
              setOpeningHours(
                page.globalSettings.globalSettingsNew.openingHours
              );
            }
            if (page.globalSettings.globalSettingsNew.smFacebook) {
              setFbLink(page.globalSettings.globalSettingsNew.smFacebook);
            }
            if (page.globalSettings.globalSettingsNew.smInstagram) {
              setInstaLink(page.globalSettings.globalSettingsNew.smInstagram);
            }
            if (page.globalSettings.globalSettingsNew.tripadvisor) {
              setAdvisorLink(page.globalSettings.globalSettingsNew.tripadvisor);
            }
            if (page.globalSettings.globalSettingsNew.logoGold) {
              if (page.globalSettings.globalSettingsNew.logoGold.node) {
                if (
                  page.globalSettings.globalSettingsNew.logoGold.node
                    .mediaItemUrl
                ) {
                  setlogoGold(
                    page.globalSettings.globalSettingsNew.logoGold.node
                      .mediaItemUrl
                  );
                }
              }
            }
            if (page.globalSettings.globalSettingsNew.logoWhite) {
              if (page.globalSettings.globalSettingsNew.logoWhite.node) {
                if (
                  page.globalSettings.globalSettingsNew.logoWhite.node
                    .mediaItemUrl
                ) {
                  setlogoWhite(
                    page.globalSettings.globalSettingsNew.logoWhite.node
                      .mediaItemUrl
                  );
                }
              }
            }
          }
          if (page.globalSettings.globalSettingsNewSmtp) {
            setGlobalSetting(page.globalSettings.globalSettingsNewSmtp);

            if (page.globalSettings.globalSettingsNewSmtp.addressLine1) {
              setMainAddress(
                page.globalSettings.globalSettingsNewSmtp.addressLine1
              );
            }
            if (page.globalSettings.globalSettingsNewSmtp.contactEmail) {
              setEmailAddress(
                page.globalSettings.globalSettingsNewSmtp.contactEmail
              );
            }
            if (page.globalSettings.globalSettingsNewSmtp.hotlineNumber) {
              setPhoneNumber(
                page.globalSettings.globalSettingsNewSmtp.hotlineNumber
              );
            }
          }
        }
      }
    };

    fetchData();
    return () => {};
  }, []);

  const handleBottomLinkClickNav = (index) => {
    setActiveBottomNavLink(index);
  };

  if (!page_data) {
    return <div></div>;
  }

  return (
    <>
      <footer className={styles.footer_main}>
        <video autoPlay muted loop>
          <source src="/footer-bg.mp4" type="video/mp4" />
          Your browser does not support the video tag.
        </video>
        <div className={styles.footer}>
          <div className={`${styles.footer_top} middle-wrap index-top d-flex`}>
            <div
              className={`${styles.footer_col_wrap} d-flex flex-wrap justify-content-between`}
            >
              <div className={`${styles.footer_col}`}>
                <h4 className="section-heading-small section-heading--white heading-padding all-caps  mobile-text-center">
                  {footer_text}
                </h4>
              </div>
              <div
                className={`middle-wrap index-top ${styles.footer_bottom_menu} mobile_el`}
              >
                <nav className={`${styles.main_menu} navbar navbar-expand-lg`}>
                  <ul className="navbar-nav">
                    {bottom_menu_items &&
                      bottom_menu_items.menuItems &&
                      bottom_menu_items.menuItems.nodes.map((menuItem) => (
                        <li
                          key={menuItem.id}
                          className={`nav-item ${
                            normalizePath(pathname) ===
                            normalizePath(menuItem.uri)
                              ? "active"
                              : ""
                          }`}
                        >
                          {menuItem.target === "_blank" ? (
                            <Link
                              href={
                                menuItem.target === "_blank"
                                  ? menuItem.url
                                  : `${process.env.APP_URL}${menuItem.uri}`
                              }
                              target={
                                menuItem.target === "_blank"
                                  ? "_blank"
                                  : undefined
                              }
                              rel={
                                menuItem.target === "_blank"
                                  ? "noopener noreferrer"
                                  : undefined
                              }
                            >
                              <span>{menuItem.label}</span>
                              <div
                                className={`next-btn-bottom-menu next-btn next-btn--white w-100`}
                              >
                                <div className="next-btn--bottom d-flex underlineLink"></div>
                              </div>
                            </Link>
                          ) : (
                            // Internal link using Next.js <Link>
                            <Link
                              href={`${process.env.APP_URL}${menuItem.uri}`}
                              passHref
                            >
                              <span>{menuItem.label}</span>
                              <div
                                className={`next-btn-bottom-menu next-btn next-btn--white w-100`}
                              >
                                <div className="next-btn--bottom d-flex w-100">
                                  <span className="next-btn--bottom-line"></span>
                                  <span className="next-btn--bottom-line"></span>
                                </div>
                              </div>
                            </Link>
                          )}
                        </li>
                      ))}
                  </ul>
                </nav>
              </div>
              <div
                className={`${styles.footer_col} ${styles.footer_col_center}`}
              >
                <p className="paragraph-small font-color--light-gray heading-padding p-b-i-90">
                  Avani+ Riverside Bangkok Hotel,
                  <br />
                  {main_address}
                </p>
                <div className="desktop-d-flex mobile-justify-center footer-logo-div desktop_el">
                  <Link target="_blank" href={seenLink}>
                    <Image
                      src="/seenl.png"
                      width={120}
                      height={40}
                      alt="seen"
                    />
                  </Link>
                  <Link target="_blank" href={avaniLink}>
                    <Image
                      src="/AvaniFooter.png"
                      width={120}
                      height={40}
                      alt="Avani Logo"
                    />
                  </Link>
                </div>
              </div>
              <div className={styles.footer_col}>
                <ul>
                  <li className="paragraph-small font-color--light-gray">
                    <span>Email : </span>
                    <a
                      className="font-color--light-gray"
                      href={`mailto:${email_address}`}
                    >
                      {email_address}
                    </a>
                  </li>
                  <li className="paragraph-small font-color--light-gray">
                    <span> Phone : </span>
                    <a
                      className="font-color--light-gray"
                      href={`tel:${phone_number}`}
                    >
                      {phone_number}
                    </a>
                  </li>
                </ul>
                <ul>
                  <li className="paragraph-small font-color--light-gray">
                    {`SIN's Opening Hours`}
                  </li>
                  <li className="paragraph-small paragraph--white">
                    {opening_hours}
                  </li>
                </ul>
                <ul className={styles.footer_social}>
                  {fb_link && (
                    <li>
                      <a target="_blank" href={fb_link}>
                        <Image
                          src="/fb.png"
                          width={50}
                          height={50}
                          alt="Facebook Icon"
                        />
                      </a>
                    </li>
                  )}
                  {insta_link && (
                    <li>
                      <a target="_blank" href={insta_link}>
                        <Image
                          src="/insta.png"
                          width={50}
                          height={50}
                          alt="Instagram Icon"
                        />
                      </a>
                    </li>
                  )}
                  {advisor_link && (
                    <li>
                      <a target="_blank" href={advisor_link}>
                        <Image
                          src="/advi.png"
                          width={50}
                          height={50}
                          alt="Advisor Icon"
                        />
                      </a>
                    </li>
                  )}
                </ul>
              </div>
              <div className="mobile-justify-center footer-logo-div mobile_el_flex w-100">
                <Link href={seenLink}>
                  <Image
                    target="_blank"
                    src="/seenl.png"
                    width={120}
                    height={40}
                    alt="seen"
                  />
                </Link>
                <Link target="_blank" href={avaniLink}>
                  <Image
                    src="/AvaniFooter.png"
                    width={120}
                    height={40}
                    alt="Avani Logo"
                  />
                </Link>
              </div>
            </div>
          </div>
          <div
            className={`middle-wrap index-top ${styles.footer_bottom_menu} desktop_el`}
          >
            <nav className={`${styles.main_menu} navbar navbar-expand-lg`}>
              <ul className="navbar-nav">
                {bottom_menu_items &&
                  bottom_menu_items.menuItems &&
                  bottom_menu_items.menuItems.nodes.map((menuItem) => (
                    <li
                      key={menuItem.id}
                      className={`nav-item ${
                        normalizePath(pathname) === normalizePath(menuItem.uri)
                          ? "active"
                          : ""
                      }`}
                    >
                      {menuItem.target === "_blank" ? (
                        <a
                          href={
                            menuItem.target === "_blank"
                              ? menuItem.url
                              : `${process.env.APP_URL}${menuItem.uri}`
                          }
                          target={
                            menuItem.target === "_blank" ? "_blank" : undefined
                          }
                          rel={
                            menuItem.target === "_blank"
                              ? "noopener noreferrer"
                              : undefined
                          }
                        >
                          <span>{menuItem.label}</span>
                          <div
                            className={`next-btn-bottom-menu next-btn next-btn--yellow w-100`}
                          >
                            <div className="next-btn--bottom d-flex w-100">
                              <span className="next-btn--bottom-line"></span>
                              <span className="next-btn--bottom-line"></span>
                            </div>
                          </div>
                        </a>
                      ) : (
                        // Internal link using Next.js <Link>
                        <Link
                          href={`${process.env.APP_URL}${menuItem.uri}`}
                          passHref
                        >
                          <span>{menuItem.label}</span>
                          <div
                            className={`next-btn-bottom-menu next-btn next-btn--white w-100`}
                          >
                            <div className="next-btn--bottom d-flex w-100">
                              <span className="next-btn--bottom-line"></span>
                              <span className="next-btn--bottom-line"></span>
                            </div>
                          </div>
                        </Link>
                      )}
                    </li>
                  ))}
              </ul>
            </nav>
          </div>
          <div className="sideLines desktop-d-flex heading-padding desktop_el">
            <div className="hrlinF">
              <hr className="fline"></hr>
            </div>
            <Link target="_blank" href="/">
              <Image src={logoGold} width={100} height={45} alt="seen" />
            </Link>
            <div className="hrlinF">
              <hr className="fline"></hr>
            </div>
          </div>
          <div className={styles.footer_bottom}>
            <div className="middle-wrap flex-wrap d-flex justify-content-between align-items-center index-top">
              <div className={styles.footer_col_first}>
                <ul>
                  {menu_items &&
                    menu_items.menuItems &&
                    menu_items.menuItems.nodes.map((menuItem) => (
                      <li
                        key={menuItem.id}
                        className={`nav-item ${
                          normalizePath(pathname) ===
                          normalizePath(menuItem.uri)
                            ? "active"
                            : ""
                        }`}
                      >
                        {menuItem.target === "_blank" ? (
                          <a
                            href={
                              menuItem.target === "_blank"
                                ? menuItem.url
                                : `${process.env.APP_URL}${menuItem.uri}`
                            }
                            target={
                              menuItem.target === "_blank"
                                ? "_blank"
                                : undefined
                            }
                            rel={
                              menuItem.target === "_blank"
                                ? "noopener noreferrer"
                                : undefined
                            }
                          >
                            <span>{menuItem.label}</span>
                            <div
                              className={`next-btn-bottom-menu next-btn next-btn--yellow w-100`}
                            >
                              <div className="next-btn--bottom d-flex w-100">
                                <span className="next-btn--bottom-line"></span>
                                <span className="next-btn--bottom-line"></span>
                              </div>
                            </div>
                          </a>
                        ) : (
                          // Internal link using Next.js <Link>
                          <Link
                            href={`${process.env.APP_URL}${menuItem.uri}`}
                            passHref
                          >
                            <span>{menuItem.label}</span>
                            <div
                              className={`next-btn-bottom-menu next-btn next-btn--white w-100`}
                            >
                              <div className="next-btn--bottom d-flex w-100">
                                <span className="next-btn--bottom-line"></span>
                                <span className="next-btn--bottom-line"></span>
                              </div>
                            </div>
                          </Link>
                        )}
                      </li>
                    ))}
                </ul>
              </div>
              <div className={styles.footer_col_second}>
                <p className="text-center m-0">
                  © {currentYear} SIN Restaurant & Bar. All rights reserved.
                </p>
              </div>
              <div className={styles.footer_col_third}>
                <p className="text-right m-0 hoverText">
                  Website Designed & Developed by
                  <a
                    className="footerlinkeme"
                    target="_blank"
                    href="https://www.emarketingeye.com"
                    rel="noopener noreferrer"
                  >
                    eMarketingEye
                  </a>
                </p>
              </div>
            </div>
          </div>
        </div>
        <div className={styles.invisible_div}></div>
      </footer>
    </>
  );
};

export default Footer;
